var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78352 8.9815L10.223 11.5685M10.2165 4.4315L5.78352 7.0185M13.85 3.45C13.85 4.52696 12.977 5.4 11.9 5.4C10.8231 5.4 9.95002 4.52696 9.95002 3.45C9.95002 2.37304 10.8231 1.5 11.9 1.5C12.977 1.5 13.85 2.37304 13.85 3.45ZM6.05002 8C6.05002 9.07695 5.17698 9.95 4.10002 9.95C3.02307 9.95 2.15002 9.07695 2.15002 8C2.15002 6.92304 3.02307 6.05 4.10002 6.05C5.17698 6.05 6.05002 6.92304 6.05002 8ZM13.85 12.55C13.85 13.627 12.977 14.5 11.9 14.5C10.8231 14.5 9.95002 13.627 9.95002 12.55C9.95002 11.473 10.8231 10.6 11.9 10.6C12.977 10.6 13.85 11.473 13.85 12.55Z",
    stroke: "currentColor",
    strokeWidth: 0.928571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.09e9a7bccd4b172aa6badf8ec900e7a4.svg";
export { ForwardRef as ReactComponent };